import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 8m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-0"}],["path",{"d":"M12 16m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-1"}]]

const IconNumber8 = createReactComponent('outline', 'number-8', 'Number8', __iconNode);

export default IconNumber8;